/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type PlanningStatus = (typeof PlanningStatus)[keyof typeof PlanningStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanningStatus = {
  ok: 'ok',
  minor: 'minor',
  critical: 'critical',
} as const;
